import { render, staticRenderFns } from "./WidgetCarouselPreview.vue?vue&type=template&id=202d585d&scoped=true"
import script from "./WidgetCarouselPreview.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselPreview.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselPreview.vue?vue&type=style&index=0&id=202d585d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d585d",
  null
  
)

export default component.exports